import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './MobileOneBanner.scss';

const MobileOneBanner = ({data, context}) => {
  const handleButtonClick = (link) => {
    if (link) {
      console.log('Navigating to:', link);
      context.navigateTo(link);
    }
  };
  const renderBackground = () => {
    if (!data.mainBackground) return null;

    if (data.mainBackgroundType === 'video') {
      return (
        <video autoPlay loop muted playsInline className="mobile-one-banner__bg">
          <source src={data.mainBackground} type="video/mp4" />
        </video>
      );
    }

    if (data.mainBackgroundType === 'image' || data.mainBackgroundType === 'gif') {
      return <Image src={data.mainBackground} alt="" className="mobile-one-banner__bg" />;
    }

    return null;
  };

  return (
    <div className="mobile-one-banner-wrapper">
      <div
        className="mobile-one-banner"
        style={{ backgroundColor: data.mainBackgroundColor }}
      >
        {renderBackground()}
        <div className="text-buttons">
          <div className="text">
            {data.mainText && (
              <div
                className="main-text"
                style={{ color: data.mainTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.mainText }}
              />
            )}
            {data.additionalText && (
              <div
                className="additional-text"
                style={{ color: data.additionalTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.additionalText }}
              />
            )}
            {data.secondaryText && (
              <div
                className="secondary-text"
                style={{ color: data.secondaryTextColor || '#FFFFFF' }}
                dangerouslySetInnerHTML={{ __html: data.secondaryText }}
              />
            )}
          </div>
          {data.mainButton && data.mainButton.link && (
            <button
              className={`button banner-button banner-button--${data.mainButton.style} ${data.secondaryButton && data.secondaryButton.link ? 'button--two-buttons' : ''}`}
              onClick={() => handleButtonClick(data.mainButton.link)}>
              <span>{data.mainButton.text}</span>
            </button>
          )}
          {data.secondaryButton && data.secondaryButton.link && (
            <button
              className={`button banner-button-secondary banner-button-secondary--${data.secondaryButton.style} button--two-buttons`}
              onClick={() => handleButtonClick(data.secondaryButton.link)}>
              {data.secondaryButton.text}
            </button>
          )}
        </div>
      </div>
    </div>

  );
};

export default MobileOneBanner;

